export default __webpack_public_path__ + "static/logos-tiles-tish-747d5aeb425a4bec72b75bc76bd189a3.svg";